import React from 'react';
import PropTypes, { shape, func, string, bool, number } from 'prop-types';
import { Icon, Button } from 'Components';
import isEdgeIE from 'helpers/detectEdgeIE';
import i18n from 'i18next';
import './MenuBar.css';

const MenuBar = ({
  activeIndex,
  onClick,
  isLocked,
  show,
  icons,
  tableIndex,
  currentRow,
}) => {
  if (!show || icons.length === 0) return null;

  const menuBar = (
    <div className="menu-bar">
      <div className="menu-bar__container">
        {icons
          .filter(icon => !isLocked || icon.showLocked)
          .filter(icon => !icon.hide)
          .map((icon, index) => (
            <Button key={`${icon.icon}-${icon.label}`} onClick={() => onClick(icon.code, tableIndex, currentRow || null)}>
              <span className={`menu-bar__container__item ${activeIndex === index ? 'menu-bar__container__item--active' : ''}`}>
                <Icon {...icon} />
                <span className="menu-bar__container__item__label">{i18n.t(`common:${icon.label}`)}</span>
              </span>
            </Button>
          ))
        }
      </div>
    </div>
  );

  if (isEdgeIE()) {
    return (
      <div className="menu-bar_IE">
        {menuBar}
      </div>
    );
  }

  return menuBar;
};

MenuBar.propTypes = {
  activeIndex: number,
  onClick: func,
  icons: PropTypes.arrayOf(shape({
    label: string,
    icon: string,
    show: bool,
    className: string,
    showLocked: bool,
    rotate: number,
  })),
  isLocked: bool,
  show: bool,
  tableIndex: PropTypes.number,
};

MenuBar.defaultProps = {
  onClick: () => { },
  icons: [],
  isLocked: false,
  show: false,
};

export default MenuBar;



// WEBPACK FOOTER //
// ./src/components/MenuBar/MenuBar.jsx